module.exports = __webpack_public_path__ + "img/LUB00341.714b9004.png";